<template>
  <div class="mainBody" id="header">
    <div class="desktopMenu">
      <div class="landingLogo">
        <a href="">
          <img :src="imgLogo" alt="">
        </a>
      </div>
      <div class="login">
        <a style="cursor: pointer" class="contact center" @click="landingPage">Back to Home</a>
        <md-button class="md-dense md-raised center" @click="toLogin" style="padding: 0">Log In or Register</md-button>
      </div>s

    </div>

    <div class="mobileMenu">
      <div class="page-container md-layout-column">
        <div class="landingLogo">
          <a href="">
            <img :src="imgLogo" alt="">
          </a>
        </div>
        <div class="md-primary">
          <div class="md-toolbar-section-end">
            <md-button @click="showSidepanel = true">
              <md-icon>menu</md-icon>
            </md-button>
          </div>
        </div>

        <md-drawer class="md-right" :md-active.sync="showSidepanel">
          <div style="margin-top: 10%">
            <div class="mobileLogin">
              <md-button style="text-transform: none; margin-right: 5%" class="md-dense md-raised center" @click="toLogin">Log In or Register</md-button>
            </div>
            <div style="text-align: center">
              <a style="font-size: 14px;color: #373737 !important;font-weight: 400;" class="contact center" @click="landingPage">Back to Home</a>
            </div>


          </div>
        </md-drawer>
      </div>
    </div>
    <br>
    <div>
      <p class="privacyPolicyHeader">Privacy Policy</p>
      <br>
      <div style="text-align: center">
        <img :src="headerImage" alt="">
      </div>
      <br>
      <p class="privacyPolicyHeaderCaption">Blood Donors’ Network Bangladesh (BDNBD),
        a social concern inspired by the spirit of those who care for other and enjoy lending a hand to those who are in need.
        BDNBD is not associated with any “Blood Bank” or affiliated/sponsored by any organization.
        Instead, a platform that uplifts the heroism of saving a life.</p>

      <hr style="margin-top:7%; width: 60%; border-top: 1px solid rgba(204,204,204,0.25);">
    </div>
    <br>
    <div class="contentWrapper">
      <p class="contentHeader">Data & Security</p>
      <p class="contentCaption">
        We do not provide any confidential information of our users to any third party organization.
        We do not preserve any personal data or sell them to anyone.
        We merely provide relevant information about potential donors to those in need of blood. <br><br>
        BDNBD uses OTP (One Time Password) to log In or Sign Up. Hence, we do not provide your contact information
        to any telemarketing organization during OTP. It’s simply an automated process to verify your identity.<br><br>
        BDNBD doesn’t have any access to your facebook profile and unable to post on your timeline without your permission.
        It connects with facebook only to make a better user experience of the platform.
      </p>

    </div>

    <div class="contentWrapper">
      <p class="contentHeader">Cookie Policy</p>
      <p class="contentCaption">
        We collect cookies only to enhance the experience of an user. Cookies remember information you entered on our website,
        or choices you made (e.g. clicking a link). We use these cookies to understand which information and/or links are more viewed,
        which functions are often used, and so on.
      </p>

    </div>

    <div class="contentWrapper">
      <p class="contentHeader">Ad Policy</p>
      <p class="contentCaption">
        BDNBD uses google ads to raise it’s funding to make the platform more intuitive. Any fraction of the revenue,
        doesn’t go into the pocket of anyone involved with the platform. We believe, users will consider our ad revenue policy
        and help us to make the app more useful and intuitive. If one feels irritated by those ads or any other content
        on the platform, he/she is welcome to report.
      </p>

    </div>

    <div class="contentWrapper">
      <p class="contentHeader">Inevitables</p>
      <p class="contentCaption">
        We do not claim that the donors are free from diseases. Or bodily conditions that prevent them from donating blood
        at the time when they are contacted for blood donation. <br><br>
        We do not guarantee that all potential donors will agree to donate blood whenever called upon to do so.
        It is entirely at the discretion of the individual whether or not to donate blood. <br><br>
        BDNBD does not arrange for blood donors. It is simply automated to help people in need of blood to communicate
        with right donors wish to donate without any need of a reward.
      </p>
    </div>

    <div class="contentWrapper">
      <p class="contentHeader">Ethics</p>
      <p class="contentCaption">
        BDNBD restricts any donor to take any money from anyone to donate blood or sell blood.
        We inspire to report immediately to us if such activity is found.
        The account of the reported user will be immediately terminated. <br><br>
        BDNBD is not for any commercial use. We do not promote any group or organization.
        It is strictly prohibited to use BDNBD to achieve any commercial benefits or goals. If one tries to do so,
        BDNBD preserves the complete right to take any legal action against that person or organization.
      </p>
    </div>
<br>
<br>
<br>
<br>
<br>
  </div>
</template>
<script>
  export default {
    data: () => ({
      showSidepanel: false
    }),

    props: {

      imgLogo: {
        type: String,
        default: require('@/assets/img/landing/logo.png')
      },
      headerImage: {
        type: String,
        default: require('@/assets/img/quotation-mark.png')
      }
    },
    methods:{
      toLogin(){
        console.log('asd')
        let routeData = this.$router.resolve({name: 'Login'});
        window.open(routeData.href, '_blank');
      },
      landingPage(){
        console.log('asssssssd')
        this.$router.push({name: 'LandingPage'});

      }
    },
    mounted() {
      var options = {
        easing: 'ease-in',
        offset: -60,
        cancelable: true,
        onStart: function(element) {
          // scrolling started
        },
        onDone: function(element) {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
      }
      this.$scrollTo('#header', 1000, options)
    }
  }
</script>
<style>
  @font-face {
    font-family: customFont;
    src: url('../assets/font/LBRITED.TTF');
  }
  .landingLogo{
    position: relative !important;
    padding: 0px !important;
    margin: 2% !important;
    z-index: 4 !important;
    float: left;
  }
  .login{
    position: relative !important;
    padding: 0px !important;
    margin: 2% !important;
    z-index: 4 !important;
    float: right;
    display: inline-block;
  }

  .center{
    width: 180px; /* Can vary too */
    padding: 22px;
    margin: 5px -35px;

    display: inline-block;
    white-space: normal;
    vertical-align: middle;
    text-align:center;
  }

  input, textarea{
    width: 60%;
    border-radius: 10px;
    background-color: #F1F1F1;
    padding: 20px;
    margin-top: 3%;
    border-width:0px;
  }


  body{
    background-color: #ffffff !important;
  }
  html.md-theme-default{
    background-color: #ffffff !important;
  }

  .login .md-button{
    background-color: #4689FF !important;
    text-transform: none;
    border-radius: 10px;
    width: 165px !important;
    height: 49px !important;
  }
  .login .md-button:hover{
    background-color: rgba(70, 137, 255, 0.81) !important;
  }

  .login a{
    font-size: 14px;
    color: #373737 !important;
    font-weight: 400;
  }
  .login a:hover{
    color: rgba(55, 55, 55, 0.81) !important;
  }

  .login a:active{
    color: #373737 !important;
  }

  .mobileLogin{
    text-align: center;
  }

  .mobileLogin .md-button{
    background-color: #4689FF !important;
    text-transform: none;
    border-radius: 10px;
    margin-right: 5%;
  }
  .mobileLogin .md-button:active{
    background-color: rgba(70, 137, 255, 0.81) !important;
  }
  .privacyPolicyHeader{
    font-family: customFont;
    text-align: center;
    margin-top: 10%;
    margin-bottom: 5%;
    font-size: 34px;
    color: #404040;
    font-weight: 500;
    line-height: 1em;
  }
  .privacyPolicyHeaderCaption{
    width: 60%;
    margin: 0 auto;
    margin-top: 2%;
    text-align: center;
    font-size: 16px;
    color: #878787;
  }
  .contentWrapper{
    width: 60%;
    margin: 0 auto
  }
  .contentHeader{
    color: #FF5454;
    font-size: 20px;
    font-weight: 400;
    margin-top: 6%
  }
  .contentCaption{
    margin-top: 5%;
  }


  @media only screen and (max-width : 992px) {

  }
  @media only screen and (max-width : 768px){
    input, textarea{
      width: 90%;
    }
    .privacyPolicyHeader{
      padding: 5%;
    }

    .desktopMenu{
      display: none;
    }

  }

  @media (min-width: 769px) {
    .mobileMenu{
      display: none;
    }
  }




</style>
